{
  "REPORT": {
    "HEADER": "Pokalbiai",
    "LOADING_CHART": "Įkeliami diagramos duomenys...",
    "NO_ENOUGH_DATA": "Negavome pakankamai duomenų, kad galėtume sugeneruoti ataskaitą. Bandykite dar kartą vėliau.",
    "DOWNLOAD_AGENT_REPORTS": "Parsisiųsti agentų ataskaitas",
    "DATA_FETCHING_FAILED": "Nepavyko gauti duomenų, bandykite dar kartą vėliau.",
    "SUMMARY_FETCHING_FAILED": "Nepavyko gauti suvestinės, bandykite dar kartą vėliau.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Pokalbiai",
        "DESC": "( Viso )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Gaunami pranešimai",
        "DESC": "( Viso )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Siunčiami pranešimai",
        "DESC": "( Viso )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Pirmojo atsakymo laikas",
        "DESC": "( Vid )",
        "INFO_TEXT": "Bendras pokalbių skaičius, naudotas skaičiavimui:",
        "TOOLTIP_TEXT": "Pirmo atsakymo laikas yra {metricValue} (remiantis {conversationCount} pokalbių)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Sprendimo laikas",
        "DESC": "( Vid )",
        "INFO_TEXT": "Bendras pokalbių skaičius, naudotas skaičiavimui:",
        "TOOLTIP_TEXT": "Sprendimo laikas yra {metricValue} (remiantis {conversationCount} pokalbių)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Sprendimų skaičius",
        "DESC": "( Viso )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Sprendimų skaičius",
        "DESC": "( Viso )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Handoff Count",
        "DESC": "( Viso )"
      },
      "REPLY_TIME": {
        "NAME": "Kliento laukimo laikas",
        "TOOLTIP_TEXT": "Waiting time is {metricValue} (based on {conversationCount} replies)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "TODAY": "Šiandien",
      "YESTERDAY": "Vakar",
      "LAST_7_DAYS": "Paskutines 7 dienas",
      "LAST_30_DAYS": "Paskutines 30 dienų",
      "THIS_MONTH": "Šis mėnuo",
      "LAST_MONTH": "Praėjęs mėnuo",
      "LAST_3_MONTHS": "Paskutinius 3 mėnesius",
      "LAST_6_MONTHS": "Paskutinius 6 mėnesius",
      "LAST_YEAR": "Paskutinius metus",
      "CUSTOM_DATE_RANGE": "Pritaikytas datos intervalas"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Taikyti",
      "PLACEHOLDER": "Pasirinkti datos intervalą"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Grupuoti pagal",
    "DURATION_FILTER_LABEL": "Trukmė",
    "GROUPING_OPTIONS": {
      "DAY": "Diena",
      "WEEK": "Savaitė",
      "MONTH": "Mėnuo",
      "YEAR": "Metai"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Diena"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Diena"
      },
      {
        "id": 2,
        "groupBy": "Savaitė"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Diena"
      },
      {
        "id": 2,
        "groupBy": "Savaitė"
      },
      {
        "id": 3,
        "groupBy": "Mėnuo"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Diena"
      },
      {
        "id": 2,
        "groupBy": "Savaitė"
      },
      {
        "id": 3,
        "groupBy": "Mėnuo"
      }
    ],
    "BUSINESS_HOURS": "Darbo valandos",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Nieko nerasta"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Pokalbiai: {count}",
      "RESULT_COUNT_MESSAGE": "Pranešimai: {count}",
      "EMPTY": "Šiam stulpeliui įrašų nerasta.",
      "ERROR": "Nepavyko įkelti įrašų. Bandykite dar kartą.",
      "LOAD_MORE": "Įkelti daugiau",
      "PREVIOUS_BUCKET": "Ankstesnis stulpelis",
      "NEXT_BUCKET": "Kitas stulpelis",
      "UNKNOWN_CONTACT": "Nežinomas kontaktas",
      "UNKNOWN_INBOX": "Nežinomas gautų laiškų aplankas",
      "UNASSIGNED_AGENT": "Nepriskirta",
      "NO_MESSAGE_CONTENT": "Pranešimas be turinio",
      "MESSAGE_CREATED_AT": "Pranešimas sukurtas {time}",
      "EVENT_OCCURRED_AT": "Įvykis įvyko {time}",
      "INCOMING_MESSAGE": "Gaunamas pranešimas",
      "OUTGOING_MESSAGE": "Siunčiamas pranešimas",
      "VIEW_ALL": "Rodyti pokalbiuose",
      "VIEW_ALL_LIMIT": "Pokalbių sąraše atidaromi tik stulpeliai, kuriuose yra ne daugiau kaip {limit} pokalbių.",
      "HIDDEN_COUNT": "Nerodoma, nes nesate jų gautų laiškų aplanko narys: {count}"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Agentų apžvalga",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent’s name to learn more.",
    "LOADING_CHART": "Įkeliami diagramos duomenys...",
    "NO_ENOUGH_DATA": "Negavome pakankamai duomenų, kad galėtume sugeneruoti ataskaitą. Bandykite dar kartą vėliau.",
    "DOWNLOAD_AGENT_REPORTS": "Parsisiųsti agentų ataskaitas",
    "FILTER_DROPDOWN_LABEL": "Pasirinkti agentą",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Pokalbiai",
        "DESC": "( Viso )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Gaunami pranešimai",
        "DESC": "( Viso )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Siunčiami pranešimai",
        "DESC": "( Viso )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Pirmojo atsakymo laikas",
        "DESC": "( Vid )",
        "INFO_TEXT": "Bendras pokalbių skaičius, naudotas skaičiavimui:",
        "TOOLTIP_TEXT": "Pirmo atsakymo laikas yra {metricValue} (remiantis {conversationCount} pokalbių)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Sprendimo laikas",
        "DESC": "( Vid )",
        "INFO_TEXT": "Bendras pokalbių skaičius, naudotas skaičiavimui:",
        "TOOLTIP_TEXT": "Sprendimo laikas yra {metricValue} (remiantis {conversationCount} pokalbių)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Sprendimų skaičius",
        "DESC": "( Viso )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Paskutines 7 dienas"
      },
      {
        "id": 1,
        "name": "Paskutines 30 dienų"
      },
      {
        "id": 2,
        "name": "Paskutinius 3 mėnesius"
      },
      {
        "id": 3,
        "name": "Paskutinius 6 mėnesius"
      },
      {
        "id": 4,
        "name": "Paskutinius metus"
      },
      {
        "id": 5,
        "name": "Pritaikytas datos intervalas"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Taikyti",
      "PLACEHOLDER": "Pasirinkti datos intervalą"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Etikečių Apžvalga",
    "DESCRIPTION": "Stebėkite žymų našumą pagal pagrindinius rodiklius: pokalbius, atsakymo laiką, sprendimo laiką ir išspręstus atvejus.",
    "LOADING_CHART": "Įkeliami diagramos duomenys...",
    "NO_ENOUGH_DATA": "Negavome pakankamai duomenų, kad galėtume sugeneruoti ataskaitą. Bandykite dar kartą vėliau.",
    "DOWNLOAD_LABEL_REPORTS": "Parsisiųsti etiketės ataskaitas",
    "FILTER_DROPDOWN_LABEL": "Pažymėti Etiketę",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Pokalbiai",
        "DESC": "( Viso )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Gaunami pranešimai",
        "DESC": "( Viso )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Siunčiami pranešimai",
        "DESC": "( Viso )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Pirmojo atsakymo laikas",
        "DESC": "( Vid )",
        "INFO_TEXT": "Bendras pokalbių skaičius, naudotas skaičiavimui:",
        "TOOLTIP_TEXT": "Pirmo atsakymo laikas yra {metricValue} (remiantis {conversationCount} pokalbių)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Sprendimo laikas",
        "DESC": "( Vid )",
        "INFO_TEXT": "Bendras pokalbių skaičius, naudotas skaičiavimui:",
        "TOOLTIP_TEXT": "Sprendimo laikas yra {metricValue} (remiantis {conversationCount} pokalbių)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Sprendimų skaičius",
        "DESC": "( Viso )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Paskutines 7 dienas"
      },
      {
        "id": 1,
        "name": "Paskutines 30 dienų"
      },
      {
        "id": 2,
        "name": "Paskutinius 3 mėnesius"
      },
      {
        "id": 3,
        "name": "Paskutinius 6 mėnesius"
      },
      {
        "id": 4,
        "name": "Paskutinius metus"
      },
      {
        "id": 5,
        "name": "Pritaikytas datos intervalas"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Taikyti",
      "PLACEHOLDER": "Pasirinkti datos intervalą"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Gautų Laiškų Aplanko Apžvalga",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "Įkeliami diagramos duomenys...",
    "NO_ENOUGH_DATA": "Negavome pakankamai duomenų, kad galėtume sugeneruoti ataskaitą. Bandykite dar kartą vėliau.",
    "DOWNLOAD_INBOX_REPORTS": "Parsisiųsti gautų laiškų aplanko ataskaitas",
    "FILTER_DROPDOWN_LABEL": "Pasirinkti gautų laiškų aplanką",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Pokalbiai",
        "DESC": "( Viso )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Gaunami pranešimai",
        "DESC": "( Viso )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Siunčiami pranešimai",
        "DESC": "( Viso )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Pirmojo atsakymo laikas",
        "DESC": "( Vid )",
        "INFO_TEXT": "Bendras pokalbių skaičius, naudotas skaičiavimui:",
        "TOOLTIP_TEXT": "Pirmo atsakymo laikas yra {metricValue} (remiantis {conversationCount} pokalbių)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Sprendimo laikas",
        "DESC": "( Vid )",
        "INFO_TEXT": "Bendras pokalbių skaičius, naudotas skaičiavimui:",
        "TOOLTIP_TEXT": "Sprendimo laikas yra {metricValue} (remiantis {conversationCount} pokalbių)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Sprendimų skaičius",
        "DESC": "( Viso )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Paskutines 7 dienas"
      },
      {
        "id": 1,
        "name": "Paskutines 30 dienų"
      },
      {
        "id": 2,
        "name": "Paskutinius 3 mėnesius"
      },
      {
        "id": 3,
        "name": "Paskutinius 6 mėnesius"
      },
      {
        "id": 4,
        "name": "Paskutinius metus"
      },
      {
        "id": 5,
        "name": "Pritaikytas datos intervalas"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Taikyti",
      "PLACEHOLDER": "Pasirinkti datos intervalą"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Komandos apžvalga",
    "DESCRIPTION": "Get a snapshot of your team’s performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "Įkeliami diagramos duomenys...",
    "NO_ENOUGH_DATA": "Negavome pakankamai duomenų, kad galėtume sugeneruoti ataskaitą. Bandykite dar kartą vėliau.",
    "DOWNLOAD_TEAM_REPORTS": "Parsisiųsti komandos ataskaitas",
    "FILTER_DROPDOWN_LABEL": "Pasirinkite komandą",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Pokalbiai",
        "DESC": "( Viso )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Gaunami pranešimai",
        "DESC": "( Viso )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Siunčiami pranešimai",
        "DESC": "( Viso )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Pirmojo atsakymo laikas",
        "DESC": "( Vid )",
        "INFO_TEXT": "Bendras pokalbių skaičius, naudotas skaičiavimui:",
        "TOOLTIP_TEXT": "Pirmo atsakymo laikas yra {metricValue} (remiantis {conversationCount} pokalbių)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Sprendimo laikas",
        "DESC": "( Vid )",
        "INFO_TEXT": "Bendras pokalbių skaičius, naudotas skaičiavimui:",
        "TOOLTIP_TEXT": "Sprendimo laikas yra {metricValue} (remiantis {conversationCount} pokalbių)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Sprendimų skaičius",
        "DESC": "( Viso )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Paskutines 7 dienas"
      },
      {
        "id": 1,
        "name": "Paskutines 30 dienų"
      },
      {
        "id": 2,
        "name": "Paskutinius 3 mėnesius"
      },
      {
        "id": 3,
        "name": "Paskutinius 6 mėnesius"
      },
      {
        "id": 4,
        "name": "Paskutinius metus"
      },
      {
        "id": 5,
        "name": "Pritaikytas datos intervalas"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Taikyti",
      "PLACEHOLDER": "Pasirinkti datos intervalą"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "CSAT Ataskaitas",
    "NO_RECORDS": "Nėra CSAT apklausos atsakymų.",
    "DOWNLOAD": "Parsisiųsti CSAT ataskaitas",
    "DOWNLOAD_FAILED": "Nepavyko parsisiųsti CSAT ataskaitų",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Pasirinkti Agentus"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Kontaktas",
        "AGENT_NAME": "Priskirtas agentas",
        "RATING": "Reitingas",
        "FEEDBACK_TEXT": "Facebook komentaras"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Iš viso atsakymų",
        "TOOLTIP": "Bendras surinktų atsakymų skaičius"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Pasitenkinimo balas",
        "TOOLTIP": "Bendras teigiamų atsakymų skaičius / Bendras atsakymų skaičius * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Atsakymo įvertinimas",
        "TOOLTIP": "Bendras atsakymų skaičius / Bendras skaičius išsiųstų CSAT apklausų pranešimų * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot Reports",
    "METRIC": {
      "CONVERSATION_COUNT": {
        "LABEL": "Pokalbių skaičius",
        "TOOLTIP": "Bendras pokalbių, kuriuose yra boto pranešimų, skaičius"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Atsakymų skaičius",
        "TOOLTIP": "Bendras siunčiamų pranešimų skaičius"
      },
      "MESSAGE_COUNT": {
        "LABEL": "AI atsakymų skaičius",
        "TOOLTIP": "Bendras boto išsiųstų atsakymo pranešimų skaičius"
      },
      "COPILOT_COUNT": {
        "LABEL": "Paruoštų atsakymų skaičius",
        "TOOLTIP": "Bendras boto agentams paruoštų copilot pasiūlymų skaičius"
      },
      "SUCCESS_RATE": {
        "LABEL": "Išspręsta naudojant AI",
        "TOOLTIP": "Pokalbių, kuriuos AI išsprendė be perdavimo agentui, procentinė dalis"
      },
      "RESOLVE_TIME": {
        "LABEL": "Sprendimo laikas",
        "TOOLTIP": "Mediana laiko nuo pirmo kliento pranešimo iki paskutinio boto / agento pranešimo"
      },
      "TOTAL_CONVERSATIONS": {
        "LABEL": "No. of Conversations",
        "TOOLTIP": "Total number of conversations handled by the bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Total Responses",
        "TOOLTIP": "Total number of responses sent by the bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Resolution Rate",
        "TOOLTIP": "Total number of conversations resolved by the bot / Total number of conversations handled by the bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Handoff Rate",
        "TOOLTIP": "Total number of conversations handed off to agents / Total number of conversations handled by the bot * 100"
      }
    },
    "GROUP_BY": {
      "NONE": "Negrupuoti",
      "INBOXES": "Gautų laiškų aplankai",
      "LABELS": "Etiketės"
    },
    "GROUPED": {
      "CHART_TITLE": "Pasiskirstymas pagal grupę",
      "BACK_TO_ALL": "Rodyti visus",
      "TABLE": {
        "INBOX": "Gautų laiškų aplankas",
        "LABEL": "Etiketė",
        "CONVERSATIONS": "Pokalbiai",
        "MESSAGES": "Pranešimai",
        "MESSAGES_TOOLTIP": "Bendras siunčiamų pranešimų skaičius",
        "AI_MESSAGES": "AI atsakymai",
        "AI_MESSAGES_TOOLTIP": "Bendras AI atsakymų skaičius, po kurio nurodomas teigiamų ir neigiamų galutinių vartotojų įvertinimų skaičius",
        "THUMBS_UP_TOOLTIP": "AI atsakymų, kuriuos galutiniai vartotojai įvertino teigiamai (nykštys aukštyn), skaičius",
        "THUMBS_DOWN_TOOLTIP": "AI atsakymų, kuriuos galutiniai vartotojai įvertino neigiamai (nykštys žemyn), skaičius",
        "PREPARED": "Paruošti atsakymai",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "Šiai grupei priklausančių pranešimų dalis nuo visų pranešimų",
        "BOT_RESPONSES": "AI atsakymų %",
        "SUGGESTION_USED": "Panaudoti atsakymai",
        "SUGGESTION_USED_TOOLTIP": "Šioje grupėje paruoštų atsakymų, kuriuos panaudojo agentai, procentinė dalis",
        "SUGGESTION_NOT_USED": "Nepanaudoti atsakymai",
        "SUGGESTION_NOT_USED_TOOLTIP": "Šios grupės pranešimų, kuriems buvo paruoštas atsakymas, bet jis nebuvo panaudotas, procentinė dalis"
      },
      "NOTES": {
        "TITLE": "Kaip skaičiuojami rodikliai",
        "CONVERSATIONS": "Pokalbių, kuriuose per pasirinktą laikotarpį buvo bent vienas siunčiamas pranešimas, skaičius.",
        "MESSAGES": "Bendras per pasirinktą laikotarpį išsiųstų siunčiamų (ne privačių) pranešimų skaičius. Tai apima tiek AI sugeneruotus, tiek žmogaus parašytus pranešimus.",
        "PERCENTAGE": "Šios grupės pranešimų dalis iš visų siunčiamų pranešimų visose grupėse.",
        "AI_MESSAGES": "Siunčiamų pranešimų, kuriuos automatiškai išsiuntė AI botas (neįskaitant agentams paruoštų atsakymų), skaičius. Skliausteliuose nurodyti skaičiai rodo, kiek iš šių atsakymų galutiniai vartotojai įvertino teigiamai (nykštys aukštyn) ir neigiamai (nykštys žemyn).",
        "PREPARED": "Copilot pasiūlymų (paruoštų atsakymų), kuriuos AI botas sugeneravo agentams per pasirinktą laikotarpį, skaičius. Tai privatūs pranešimai, matomi tik agentams, ir jie nėra skaičiuojami kaip siunčiami pranešimai, todėl šis skaičius gali nesutapti su stulpeliu „Pranešimai“.",
        "SUGGESTION_USED": "Šios grupės paruoštų atsakymų, kuriuos panaudojo agentai, procentinė dalis. Tai gali nesutapti su paruoštų atsakymų skaičiumi, nes gali apimti ir ankstesniais laikotarpiais sugeneruotus pasiūlymus.",
        "SUGGESTION_NOT_USED": "Šios grupės siunčiamų pranešimų, kuriems buvo pasiūlytas copilot pasiūlymas, bet agentas atsakė jo nepanaudojęs, procentinė dalis. Skaičiuojama tik tada, kai agentas iš tikrųjų išsiuntė atsakymą. Tai gali nesutapti su paruoštų atsakymų skaičiumi, nes gali apimti ir ankstesniais laikotarpiais sugeneruotus pasiūlymus."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Apžvalga",
    "LIVE": "Tiesiogiai",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Atidaryti pokalbius",
      "LOADING_MESSAGE": "Įkeliama pokalbio metrika...",
      "OPEN": "Atidaryti",
      "UNATTENDED": "Be priežiūros",
      "UNASSIGNED": "Ne priskirtas",
      "PENDING": "Laukiama"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Pokalbių srautas",
      "NO_CONVERSATIONS": "Pokalbių nėra",
      "CONVERSATION": "{count} pokalbis",
      "CONVERSATIONS": "{count} pokalbiai",
      "DOWNLOAD_REPORT": "Download report"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Agentų pokalbiai",
      "LOADING_MESSAGE": "Įkeliama agento metrika...",
      "NO_AGENTS": "Agentų pokalbių nėra",
      "TABLE_HEADER": {
        "AGENT": "Agentas",
        "OPEN": "Atidaryti",
        "UNATTENDED": "Be priežiūros",
        "STATUS": "Būsena"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Komanda",
        "OPEN": "Atidaryti",
        "UNATTENDED": "Be priežiūros",
        "STATUS": "Būsena"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Agento būsena",
      "ONLINE": "Prisijungęs",
      "BUSY": "Užimta",
      "OFFLINE": "Atsijungęs"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Sekmadienis",
    "MONDAY": "Pirmadienis",
    "TUESDAY": "Antradienis",
    "WEDNESDAY": "Trečiadienis",
    "THURSDAY": "Ketvirtadienis",
    "FRIDAY": "Penktadienis",
    "SATURDAY": "Šeštadienis"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA Reports",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Loading SLA data...",
    "DOWNLOAD_SLA_REPORTS": "Download SLA reports",
    "DOWNLOAD_FAILED": "Failed to download SLA Reports",
    "DROPDOWN": {
      "ADD_FIlTER": "Pridėti Filtrą",
      "CLEAR_ALL": "Clear all",
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Nieko nerasta",
      "NO_FILTER": "No filters available",
      "SEARCH": "Search filter",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA name",
        "AGENTS": "Agento Vardas",
        "INBOXES": "Gautų laiškų aplanko pavadinimas",
        "LABELS": "Etiketės pavadinimas",
        "TEAMS": "Komandos pavadinimas"
      },
      "SLA": "SLA Policy",
      "INBOXES": "Gautų laiškų aplankas",
      "AGENTS": "Agentas",
      "LABELS": "Etiketė",
      "TEAMS": "Komanda"
    },
    "WITH": "with",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Hit Rate",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Number of Misses",
        "TOOLTIP": "Total SLA misses in a certain period"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Number of Conversations",
        "TOOLTIP": "Total number of conversations with SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Policy",
        "CONVERSATION": "Pokalbis",
        "AGENT": "Agentas"
      },
      "VIEW_DETAILS": "View Details"
    }
  },
  "SUMMARY_REPORTS": {
    "SUBTOTAL": "Tarpinė suma",
    "NO_TEAM": "Nėra komandos",
    "GROUP_BY_TEAMS": "Grupuoti pagal komandas",
    "INBOX": "Gautų laiškų aplankas",
    "AGENT": "Agentas",
    "TEAM": "Komanda",
    "LABEL": "Žyma",
    "TOTAL": "Iš viso",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Sprendimų skaičius",
    "CONVERSATIONS": "Pokalbių kiekis",
    "OUTGOING_CHATS": "Siunčiami pokalbiai",
    "OUTGOING_EMAILS": "Siunčiami el. laiškai",
    "PHONE_CALLS": "Telefono skambučiai",
    "INBOUND_CALLS": "Įeinantys skambučiai",
    "OUTBOUND_CALLS": "Išeinantys skambučiai",
    "TOTAL_ACTIVITIES": "Iš viso veiklų",
    "ONLINE_TIME": "Prisijungimo laikas",
    "QUEUE_AVAILABLE_TIME": "Pasiekiamumo eilėje laikas",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Šio agento išsiųstų pranešimų skaičius",
      "OUTGOING_EMAILS": "Šio agento išsiųstų el. laiškų skaičius",
      "PHONE_CALLS": "Bendras šiam agentui priskirtų telefono skambučių skaičius (įeinančių ir išeinančių skambučių suma)",
      "TOTAL_ACTIVITIES": "Bendras veiklų skaičius: įeinantys skambučiai + išeinantys skambučiai + siunčiami pokalbiai + siunčiami el. laiškai",
      "INBOUND_CALLS": "Šiam agentui priskirtų įeinančių telefono skambučių skaičius",
      "OUTBOUND_CALLS": "Šiam agentui priskirtų išeinančių telefono skambučių skaičius",
      "AVG_FIRST_RESPONSE_TIME": "Vidutinis laikas nuo pokalbio sukūrimo iki pirmo agento atsakymo šiam agentui priskirtuose pokalbiuose",
      "AVG_RESOLUTION_TIME": "Vidutinis laikas nuo pokalbio sukūrimo iki išsprendimo šiam agentui priskirtuose pokalbiuose",
      "AVG_REPLY_TIME": "Vidutinis laikas, kurį klientai laukia nuo savo pranešimo iki agento atsakymo šiam agentui priskirtuose pokalbiuose",
      "ONLINE_TIME": "Bendras laikas, kai agentas per pasirinktą laikotarpį buvo prisijungęs arba užsiėmęs",
      "QUEUE_AVAILABLE_TIME": "Bendras laikas, kai agentas per pasirinktą laikotarpį buvo pasiekiamas skambučių eilėse"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Skambučių ataskaitos",
    "DESCRIPTION": "Stebėkite skambučių rodiklius su išsamiais įeinančių ir išeinančių skambučių duomenimis, sugrupuotais pagal agentą ar gautų laiškų aplanką, kad galėtumėte atlikti išsamią analizę.",
    "DOWNLOAD_PHONE_REPORTS": "Atsisiųsti skambučių ataskaitas",
    "GROUP_BY": {
      "LABEL": "Grupuoti pagal",
      "AGENT": "Agentas",
      "INBOX": "Gautų laiškų aplankas"
    },
    "TABLE": {
      "TOTAL_CALLS": "Iš viso",
      "INBOUND_CALLS": "Įeinantys",
      "OUTBOUND_CALLS": "Išeinantys",
      "FAILED_OUTBOUND_CALLS": "Nepavykę išeinantys",
      "AVG_AGENT_HANDLED_DURATION": "Vid. trukmė",
      "TOTAL_AGENT_HANDLED_DURATION": "Bendra trukmė",
      "AVG_RINGING_TIME": "Vid. skambėjimo laikas",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Sėkmės %",
      "UNIQUE_CALLERS": "Unikalūs skambinantieji",
      "UNIQUE_CALLED_CONTACTS": "Unikalūs paskambinti",
      "UNANSWERED_MISSED_CALLS": "Praleisti be perskambinimo",
      "UNANSWERED_MISSED_PERCENTAGE": "Praleisti be perskambinimo %",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Praleisti be perskambinimo, nepakankamai perskambinta",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Praleisti be perskambinimo, nepakankamai perskambinta %"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Bendras visų skambučių skaičius (įskaitant nesujungtus)",
      "INBOUND_CALLS": "Sujungtų skambučių skaičius",
      "OUTBOUND_CALLS": "Visų išeinančių skambučių skaičius (įskaitant nesujungtus)",
      "FAILED_OUTBOUND_CALLS": "Išeinančių skambučių, kurių nepavyko sujungti, skaičius",
      "AVG_AGENT_HANDLED_DURATION": "Vidutinė agentų apdorotų skambučių trukmė",
      "TOTAL_AGENT_HANDLED_DURATION": "Bendra visų agentų apdorotų skambučių trukmė",
      "AVG_RINGING_TIME": "Vidutinis laikas, kurį skambučiai skambėjo prieš atsiliepiant",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Išeinančių skambučių, kurie buvo sėkmingai sujungti, procentinė dalis",
      "UNIQUE_CALLERS": "Unikalių kontaktų, skambinusių įeinančiais skambučiais, skaičius",
      "UNIQUE_CALLED_CONTACTS": "Unikalių kontaktų, kuriems paskambinta išeinančiais skambučiais, skaičius",
      "UNANSWERED_MISSED_CALLS": "Praleistų skambučių, į kuriuos nebuvo sėkmingai perskambinta (skambutis sujungtas), skaičius. Gali apimti skambučius, kuriuos dar galima apdoroti per darbo dieną",
      "UNANSWERED_MISSED_PERCENTAGE": "Unikalių skambinančiųjų, kurių skambučiai buvo praleisti be tolesnio perskambinimo, procentinė dalis (praleisti skambučiai be perskambinimo / unikalūs skambinantieji)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Praleistų skambučių, į kuriuos perskambinta mažiau nei 2 kartus, skaičius. Gali apimti skambučius, kuriuos dar galima apdoroti per darbo dieną",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Unikalių skambinančiųjų, į kuriuos perskambinta mažiau nei 2 kartus, procentinė dalis ((praleisti be perskambinimo - pakankamai apdoroti) / unikalūs skambinantieji)"
    }
  }
}
